// Central place for your site URL & defaults
export const SITE_NAME = 'Fuel Clubs';
export const SITE_URL = 'https://www.fuelclubs.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;
